<a
  class="icon-wrap"
  target="_blank"
  *ngIf="media; else noAttachment"
  (click)="download(media.url)"
  [style.cursor]="'pointer'"
>
  <wchfs-icon [color]="'primary'" svgIcon="pso-legacy:attachment_ico" size="22"></wchfs-icon>
</a>

<ng-template #noAttachment>
  <div class="icon-wrap">
    <wchfs-icon svgIcon="pso-legacy:attachment_ico" size="22"></wchfs-icon>
  </div>
</ng-template>
